module.exports = __webpack_public_path__ + "static/media/farePremierCrown.7e3d7105.svg";